export default function PatternGreen({ className = '' }) {
  return (
    <div className={`overflow-hidden bg-[#03170f] ${className || 'relative'}`} aria-hidden="true">
      <img
        src="/assets/pattern-black.webp"
        alt=""
        loading="lazy"
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover"
      />
    </div>
  );
}
